import { GlobalScope_instance3t6qd3g1xr5c0 as GlobalScope_instance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  writer1eia5its2a1fh as writer,
  writeFully1yd4favg5iwxl as writeFully,
  close3semq7pafb42g as close,
  WriterScope3b0bo1enaee6b as WriterScope,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteWriteChannelOperations.mjs';
import { get_ByteArrayPool3f7yrgvqxz9ct as get_ByteArrayPool } from '../../../../../ktor-ktor-io/io/ktor/utils/io/pool/ByteArrayPool.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { readAvailable2v9sgy82btrhn as readAvailable } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  add2suhfggl4zvkk as add,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function observable(_this__u8e3s4, context, contentLength, listener) {
  var tmp = GlobalScope_instance;
  return writer(tmp, context, true, observable$slambda_0(_this__u8e3s4, listener, contentLength)).e4k_1;
}
var observable$slambdaClass;
function observable$slambda() {
  if (observable$slambdaClass === VOID) {
    class $ {
      constructor($this_observable, $listener, $contentLength) {
        this.b5z_1 = $this_observable;
        this.c5z_1 = $listener;
        this.d5z_1 = $contentLength;
      }
      *p58($this$writer, $completion) {
        var tmp0 = get_ByteArrayPool();
        $l$block: {
          // Inline function 'io.ktor.utils.io.pool.useInstance' call
          var instance = tmp0.y4l();
          try {
            var bytesSend = 0n;
            $l$loop: while (!this.b5z_1.a4j()) {
              var read = yield* readAvailable(this.b5z_1, instance, VOID, VOID, $completion);
              if (read <= 0)
                continue $l$loop;
              yield* writeFully($this$writer.g4k_1, instance, 0, read, $completion);
              // Inline function 'kotlin.Long.plus' call
              var this_0 = bytesSend;
              bytesSend = add(this_0, fromInt(read));
              yield* this.c5z_1.z5k(bytesSend, this.d5z_1, $completion);
            }
            var closedCause = this.b5z_1.y4i();
            close($this$writer.g4k_1, closedCause);
            if (closedCause == null && bytesSend === 0n) {
              yield* this.c5z_1.z5k(bytesSend, this.d5z_1, $completion);
            }
            break $l$block;
          }finally {
            tmp0.z4l(instance);
          }
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.p58(p1 instanceof WriterScope() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    observable$slambdaClass = $;
  }
  return observable$slambdaClass;
}
function observable$slambda_0($this_observable, $listener, $contentLength) {
  var i = new (observable$slambda())($this_observable, $listener, $contentLength);
  var l = ($this$writer, $completion) => i.p58($this$writer, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  observable as observable2pw4p3n7s3klf,
};
//endregion

//# sourceMappingURL=ByteChannelUtils.mjs.map
